/**
 * CalendarMappingEvents
 *
 * Simple event emitter for calendar-member mapping changes.
 * Allows components like the calendar, home, and family screens
 * to subscribe to mapping updates (link/unlink).
 */

type EventListener = () => void;

class CalendarMappingEventsManager {
  private listeners: Set<EventListener> = new Set();

  /**
   * Subscribe to calendar mapping changes.
   * Returns an unsubscribe function.
   */
  subscribe(listener: EventListener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  /**
   * Emit a mappings changed event to all subscribers.
   */
  emitMappingsChanged(): void {
    this.listeners.forEach(listener => {
      try {
        listener();
      } catch (error) {
        console.error('[CalendarMappingEvents] Listener error:', error);
      }
    });
  }
}

export const CalendarMappingEvents = new CalendarMappingEventsManager();
